import React, { useState, useRef } from 'react'
import { Table, Button, Space } from 'antd'
import { useLocalization } from '@contexts/LocalizationContext'
import { ReloadOutlined } from '@ant-design/icons'
import Fetch from '@components/CRUD/Fetch'
import ListOperation from '@components/CRUD/ListOperation'
import PageLayout from '@layouts/PageLayout'
import { client } from '@utils/client'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const columns = [
    {
      title: t('article.listScreen.column.title'),
      dataIndex: 'title',
      key: 'title',
      width: '15%',
    },
    {
      title: t('article.listScreen.column.url'),
      dataIndex: 'url',
      key: 'url',
      width: '15%',
    },
    {
      title: t('article.listScreen.column.titleEn'),
      dataIndex: 'titleEn',
      key: 'titleEn',
      width: '15%',
    },
    {
      title: t('article.listScreen.column.urlEn'),
      dataIndex: 'urlEn',
      key: 'urlEn',
      width: '15%',
    },
    {
      title: t('article.listScreen.column.checklist'),
      dataIndex: 'checklistMaps',
      key: 'checklistMaps',
      width: '20%',
      render: function checklistMaps(item) {
        return (
          <Space direction="vertical">
            {item.map((v) => {
              return (
                <Button
                  type={v.forStatus === 'notSure' ? 'default' : 'primary'}
                  danger={v.forStatus === 'failed' ? true : false}
                  key={v.articleId}
                  shape="round"
                >
                  {v.checklist.title}
                </Button>
              )
            })}
          </Space>
        )
      },
    },
    {
      width: '20%',
      title: t('article.listScreen.column.action'),
      render: function Action(record) {
        return (
          <ListOperation
            row={record}
            basePath="/articles"
            deletePath={`/article/${record.id}`}
            handleReload={handleReload}
          />
        )
      },
    },
  ]

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async () => {
    const result = await client
      .get('/article', {
        params: {
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      })
      .then((res) => res.data)
    return result
  }

  return (
    <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title={t('article.listScreen.title')}
          shownBack={false}
          createPath="/articles/create"
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('hospital.listScreen.reload')}
            </Button>,
          ]}
        >
          <Table
            rowKey="id"
            columns={columns}
            dataSource={data}
            onChange={handleChange}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          ></Table>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
